import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const RetrieveQuote = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/quote-expired/components/QuoteExpiredContent'
      )
  ),
  Footer: lazy(
    () =>
      import(
        'components/direct-sales/quote-expired/components/QuoteExpiredFooter'
      )
  )
};

export default RetrieveQuote;
